import { render, staticRenderFns } from "./InvoiceSales.vue?vue&type=template&id=4a6dc890&scoped=true"
import script from "./InvoiceSales.vue?vue&type=script&lang=js"
export * from "./InvoiceSales.vue?vue&type=script&lang=js"
import style0 from "./InvoiceSales.vue?vue&type=style&index=0&id=4a6dc890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6dc890",
  null
  
)

export default component.exports